import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generateEobPdf = (
  claimData,
  expenseData,
  adjudicator,
  employee,
  company,
  status,
  type
) => {
  const toDataURL = (url) =>
    new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });

  Promise.all([
    toDataURL("/corehealthinvoicelogo.png"),
  ]).then(([logoImage]) => {
    const { claim, images } = claimData;
    const formattedDate = moment(claim.claimDate).utc().format("MMM DD, YYYY");
    const approvedAmount = claim.totalApproved.toFixed(2);
    const claimedAmount = claim.totalClaimed.toFixed(2);

    const tableBody = [
      [
        { text: "Service Date", bold: true },
        { text: "Patient", bold: true },
        { text: "Category", bold: true },
        { text: "Type", bold: true },
        { text: "Expense ($)", bold: true },
        { text: "Claimed ($)", bold: true },
        { text: "Coverage (%)", bold: true },
        { text: "Approved ($)", bold: true },
        { text: "Notes", bold: true },
      ],
    ];

    expenseData.forEach((item) => {
      const expenseNotes = item.details
        .map((detail) => {
          if (detail.messageCode) {
            return `${detail.messageText} (${detail.messageCode})`;
          }
          return detail.messageText;
        })
        .join("; ");

      const image = images?.find((img) => img.id === item.claimImageId);
      const category = image?.isWaiver
        ? `Waiver: ${image.reference}`
        : item.expenseDesc;

      tableBody.push([
        moment(item.treatmentDate).utc().format("MMM DD, YYYY") || "",
        item.patient || "",
        category || "",
        item.policyCustomCategoryId === null ? "General" : "Enhanced",
        `$${item.expenseAmount.toFixed(2)}`,
        `$${item.claimedAmount.toFixed(2)}`,
        `${item.coverageRate.toFixed(0)}%`,
        `$${item.approvedAmount.toFixed(2)}`,
        { text: expenseNotes, fontSize: 6 },
      ]);
    });

    const docDefinition = {
      pageMargins: [40, 100, 40, 60],
      content: [
        {
          image: logoImage,
          width: 200,
          absolutePosition: { x: 40, y: 30 },
        },
        {
          text: `Claim ${claim.claimNo}`,
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 10],
        },
        {
          columns: [
            {
              width: "*",
              stack: [
                {
                  text: `Employee: ${employee.firstName} ${employee.nickname ? "(" + employee.nickname + ")" : ""} ${employee.maidenName ? employee.maidenName : ""} ${employee.lastName}`,
                  fontSize: 9,
                },
                { text: `Company: ${company.name}`, fontSize: 9 },
                { text: `Claim Created: ${formattedDate}`, fontSize: 9 },
                { text: `Claim Status: ${status}`, fontSize: 9 },
                { text: `Claim Type: ${type}`, fontSize: 9 },
              ],
            },
            {
              width: "auto",
              stack: [
                {
                  text: "Total amounts for this summary",
                  fontSize: 10,
                  bold: true,
                  alignment: "right",
                  margin: [0, 0, 0, 5],
                },
                {
                  text: `Claimed Total: $${claimedAmount}`,
                  fontSize: 12,
                  alignment: "right",
                },
                {
                  text: `Approved Total: $${approvedAmount}`,
                  fontSize: 12,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            headerRows: 1,
            widths: ["*", "*", "*", "*", "*", "*", "*", "*", "*"],
            body: tableBody,
          },
          layout: {
            hLineColor: "#ccc",
            vLineColor: "#ccc",
          },
          fontSize: 8,
          margin: [0, 10, 0, 10],
        },
        {
          text: [
            "If you have any questions about your claim benefit summary, please call National HealthClaim at (866) 342-5908 or email us at ",
            {
              text: "support@nationalhealthclaim.com",
              color: "#4987ef",
              link: "mailto:support@nationalhealthclaim.com",
            },
            ".",
          ],
          fontSize: 8,
          margin: [0, 20, 0, 0],
        },
      ],
    };

    pdfMake.createPdf(docDefinition).open();
  });
};
